/* eslint-disable no-unused-vars */
import Vue from 'vue'
import { getField, updateField } from 'vuex-map-fields'
import { v4 as uuidv4 } from 'uuid'
const initialState = {
  items: [],
  error: false,
  isSynced: false,
}

export default {
  namespaced: true,
  state: {
    ...initialState,
  },
  getters: {
    getField,
    getById(state) {
      return (id, idField = 'id') => state.items.find(item => item[idField] === id) || {}
    },
    comments(state) {
      if (state.error) return []

      return state.items
    },
    commentCount(state) {
      if (state.error) return []

      return state.items.length
    },
    commentsToSync: state => state.items.filter(comment => (comment.updated || comment.new)),
    encounterCommentsCount: (state) => (encounterId) => {
      return state.items.filter(
        comment => comment.source !== 'insurance_auth' && comment.encounter_id === encounterId
      ).length
    },
  },
  mutations: {
    updateCommentSync: (state, value) => {
      // Find the comment index
      const index = state.items.findIndex(x => (value.id ? (x.id === value.id) : (x.comment === value.comment) && (x.created === value.created)))

      // Update patient values
      state.items[index] = { ...value }

      state.isSynced = false
    },
    updateField,
    RESET_STATE: state => {
      Object.keys(initialState).forEach(key => {
        state[key] = initialState[key]
      })
    },
    RESET_ITEMS: state => {
      state.items = []
    },
    SET_COMMENTS(state, { data }) {
      if (state.items.length === 0) {
        state.items = data.comments
      } else {
        data.comments.forEach(newComment => {
          const existingIndex = state.items.findIndex(old =>
            old.id === newComment.id
          )

          if (existingIndex !== -1) {
            Vue.set(state.items, existingIndex, { ...state.items[existingIndex], ...newComment })
          } else {
            state.items.push(newComment)
          }
        })
      }
    },
    ADD_COMMENT: (state, value) => {
      const newValue = {
        id: uuidv4(),
        ...value,
        new: true,
      }
      state.items.push(newValue)
    },
  },
  actions: {
    syncComment({ commit }, data) {
      let commentsToSync = []

      // eslint-disable-next-line no-unused-expressions
      Array.isArray(data) ? commentsToSync = data : commentsToSync.push(data)

      return Vue.axios.put('comments/123.json', commentsToSync)
        .then(response => ((response.data.status === 'Error' && response.data.message)
          ? response.data.message
          : response.data.status === 'Success'))
        .catch(e => Vue.prototype.$custom.processCommError(e, 'upload comment'))
    },
    postComment({ commit }, data) {
      let commentsToSync = []

      // eslint-disable-next-line no-unused-expressions
      Array.isArray(data) ? commentsToSync = data : commentsToSync.push(data)

      return Vue.axios.post('comments.json', commentsToSync)
        .then(response => ((response.data.status === 'Error' && response.data.message)
          ? response.data.message
          : response.data.status === 'Success'))
        .catch(e => Vue.prototype.$custom.processCommError(e, 'post comment'))
    },
    fetchComments({ commit }) {
      commit('encounters/SET_SYNCING_TXT', 'Fetching comments', { root: true })

      return Vue.axios.get('comments.json')
        .then(response => {
          if (response.data.status === 'Success') {
            commit('SET_COMMENTS', response)
            return true
          }
          return response
        })
        .catch(e => Vue.prototype.$custom.processCommError(e, 'download comments'))
    },
    loadComments({ dispatch }) {
      return dispatch('fetchComments')
    },
    reloadComments({ commit, dispatch }) {
      commit('RESET_ITEMS')
      return dispatch('fetchComments')
    },
  },
}
